<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import OrdenarLeilao from './FiltroOrdenarLeilao'
  import Service from '../../../../domain/leiloes/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { forEach as _forEach, debounce } from 'lodash'
  import ImportProgress from '../../documentos/components/ImportProgress'
  import Importador from '../Importador'
  import {STATUS_ENCERRADO} from '../../../../domain/leiloes/helpers/LeilaoStatus'
  import {formatDate} from '../../../../utils/date'
  import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

export default {
    components: {
      Importador,
      ImportProgress,
      UPagination,
      OrdenarLeilao
    },
    mixins: [AclCheckMixins],
    nome: 'leilao',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        isLoading: false,
        leiloes: null,
        paginationLimits: [30, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 30
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: ''
        },
        prevent: {},
        isUploadingImport: false,
        activeImport: false,
        importStatus: {
          percent: 0,
          finish: false,
          mostrarErros: false,
          historico: {
            leiloes: 0,
            lotes: 0,
            erros: 0,
            logErros: []
          },
          preProcessarImportacao: false,
          processarImportacao: false,
          dadosImportacao: null
        },
        listaCache: {}
      }
    },
    computed: {
      noLeiloes () {
        if (this.leiloes === null) {
          return false
        }
        if (this.leiloes.length === 0) {
          return true
        }
        return false
      },
      proximosLeiloes () {
        const getDate = date => formatDate(date, 'YYYY-MM-DD')
        const getTime = ({date}) => new Date(date).getTime()
        const sortByDataAbertura = (a, b) => {
          const dateA = new Date(a.dataAbertura.date)
          const dateB = new Date(b.dataAbertura.date)
          if (dateA > dateB) return 1
          if (dateA < dateB) return -1
          return 0
        }
        const filterStartingTomorrow = ({dataAbertura}) => {
          const today = new Date()
          const tomorrow = new Date()
          tomorrow.setDate(today.getDate() + 1)
          const isTomorrow = getDate(tomorrow) === getDate(new Date(getTime(dataAbertura)))
          return isTomorrow || (new Date(dataAbertura.date)) > tomorrow
        }
        const proximos = (this.leiloes || []).filter(filterStartingTomorrow).sort(sortByDataAbertura)
        if (!proximos.length) return []
        const {dataAbertura} = proximos[0]
        return proximos.filter(leilao => getTime(leilao.dataAbertura) === getTime(dataAbertura))
      }
    },
    mounted () {
      this.carregaLeiloes(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id) {
        this.$router.push({name: 'leiloes.visualizar', params: {id: id}})
      },

      carregaLeiloes (limit, page, filtros) {
        this.leiloes = null
        this.isLoading = true
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.leiloes = response.data.leiloes
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.carregaLeiloes(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.leiloes, key, Object.assign({}, this.leiloes[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          if (this.checkeds < this.leiloes.length) {
            this.checkedAll = false
          } else {
            this.checkedAll = true
          }
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        // Busca
        if (filtros.busca.length > 0) {
          mount += '&busca=' + filtros.busca
        }
        return mount
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.carregaLeiloes(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      importar (e) {
        this.isUploadingImport = true
        this.activeImport = true
        this.importStatus.finish = false
        let formData = new FormData()
        formData.append('file', e.target.files[0], e.target.files[0].name)
        e.target.value = ''
        Service.importar(formData, (e) => {
          console.log('Upload in progress...')
          console.log(e)
          let percent = e.loaded / e.total * 100
          this.importStatus.percent = percent
          if (percent >= 100) {
            window.setTimeout(() => {
              this.isUploadingImport = false
            }, 1000)
          }
        })
          .then((response) => {
            window.setTimeout(() => {
              this.isUploadingImport = false
              this.importStatus.finish = true
              this.importStatus.historico = response.data.historico
            }, 1000)
            console.log(response)
          })
          .catch((response) => {
            this.isUploadingImport = false
            window.alert('Não foi possível importar, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      },
      finalizarImportacao (file) {
        this.importStatus.preProcessarImportacao = true
        Service.importarProcessar(file)
          .then((response) => {
            this.importStatus.dadosImportacao = response.data
            this.importStatus.finish = false
            this.importStatus.processarImportacao = true
          })
          .catch((response) => {
            window.alert('Não foi possível importar, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      },
      isHoje ({id, dataAbertura}) {
        if (typeof this.listaCache[id] !== 'undefined') return this.listaCache[id].isHoje
        const formataData = date => `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
        const today = new Date()
        dataAbertura = new Date(dataAbertura.date)
        if (!dataAbertura) return false
        const isHoje = formataData(today) === formataData(dataAbertura)
        this.listaCache[id] = {isHoje}
        return isHoje
      },
      isHojeEncerrado (data) {
        return this.isHoje(data) && data.status === STATUS_ENCERRADO
      },
      isProximoLeilao ({id}) {
        if (typeof this.listaCache[id].isProximoLeilao !== 'undefined') return this.listaCache[id].isProximoLeilao
        const isProximo = this.proximosLeiloes.some(l => l.id === id)
        this.listaCache[id].isProximoLeilao = isProximo
        return isProximo
      },
      analisaClassCss (leilao) {
        return {
          'bg-leilao-hoje-opacity': this.isHoje(leilao),
          'bg-leilao-encerrado-opacity': this.isHojeEncerrado(leilao),
          'bg-leilao-proximo': this.isProximoLeilao(leilao)
        }
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Leilões <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <ordenar-leilao></ordenar-leilao>
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">

                    <router-link :to="{name: 'leiloes.novo'}" tag="button" class="btn btn-default btn-sm " v-if="!isRestritoVisitante"><i
                      class="fa fa-plus"></i>
                      Novo Leilão
                    </router-link>
                    <u-button :disabled="isUploadingImport" class="btn btn-default btn-sm fileContainer hidden-print">
                      <i class="glyphicon glyphicon-import"></i> Importar
                      <input @change="importar"
                             accept=".json, application/json"
                             type="file"/>
                    </u-button>

                  </div>
                </div>
              </div>

              <transition name="slide" appear>
                <div class="wrapper content-transition" v-if="activeImport">
                  <transition name="slide2">
                    <div class="content-transition" v-if="isUploadingImport">
                      <h4 class="text-center">Importando</h4>
                      <import-progress :percent="importStatus.percent"></import-progress>
                    </div>
                  </transition>
                  <transition name="slide2">
                    <div class="content-transition text-center"
                         v-if="!isUploadingImport && activeImport && !importStatus.finish && !importStatus.processarImportacao">
                      <div><i class="fa fa-spinner fa-spin"></i></div>
                      Analisando dados
                    </div>
                  </transition>
                  <transition name="slide2">
                    <div class="content-transition text-left" v-if="importStatus.finish">
                      Dados a serem importados<br><br>
                      <table class="table table-bordered table-condensed table-striped">
                        <tbody>
                        <tr>
                          <td>Leilões</td>
                          <td class="font-bold">
                            {{ importStatus.historico.leiloes }}
                            <span
                              v-if="importStatus.historico.leiloesNovos && importStatus.historico.leiloesEncontrados">
                            <br>{{ importStatus.historico.leiloesNovos }} novo{{importStatus.historico.leiloesNovos>1 ? 's' : ''}} e {{ importStatus.historico.leiloesEncontrados }} {{importStatus.historico.leiloesEncontrados>1 ? ' serão atualizados' : ' será atualizado'}}
                          </span>
                            <span v-else-if="importStatus.historico.leiloesNovos"> novo{{importStatus.historico.leiloesNovos>1 ? 's' : ''}}</span>
                            <span v-else="importStatus.historico.leiloesEncontrados"> {{importStatus.historico.leiloesEncontrados>1 ? ' serão atualizados' : ' será atualizado'}}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Lotes</td>
                          <td class="font-bold">
                            {{ importStatus.historico.lotes }}
                            <span v-if="importStatus.historico.lotesNovos && importStatus.historico.lotesEncontrados">
                            <br>{{ importStatus.historico.lotesNovos }} novo{{importStatus.historico.lotesNovos>1 ? 's' : ''}} e {{ importStatus.historico.lotesEncontrados }} {{importStatus.historico.lotesEncontrados>1 ? ' serão atualizados' : ' será atualizado'}}
                          </span>
                            <span v-else-if="importStatus.historico.lotesNovos"> novo{{importStatus.historico.lotesNovos>1 ? 's' : ''}}</span>
                            <span v-else="importStatus.historico.lotesEncontrados"> {{importStatus.historico.lotesEncontrados>1 ? ' serão atualizados' : ' será atualizado'}}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Erros</td>
                          <td class="font-bold">
                            {{ importStatus.historico.erros }}
                            <a v-if="importStatus.historico.erros > 0" class="text-danger m-l-xs"
                               @click="importStatus.mostrarErros = !importStatus.mostrarErros">{{
                              importStatus.mostrarErros ? 'ocultar' : 'mostrar' }} erros</a></td>
                        </tr>
                        </tbody>
                      </table>
                      <button v-if="!importStatus.preProcessarImportacao" class="btn btn-lg btn-success"
                              @click="finalizarImportacao(importStatus.historico.file)">Continuar importação
                      </button>
                      <span v-if="importStatus.preProcessarImportacao">Por favor aguarde...</span>
                      <table v-if="importStatus.mostrarErros" class="table">
                        <tbody>
                        <tr v-for="erro in importStatus.historico.logErros">
                          <td>{{ erro }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </transition>
                  <transition name="slide2">
                    <importador class="content-transition" v-if="importStatus.processarImportacao"
                                :dados="importStatus.dadosImportacao"></importador>
                  </transition>
                </div>
              </transition>

            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-9 m-b-xs">
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Iniciar Campanha de Marketing
                  </button>
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Deletar
                  </button>
                </div>
                <div class="col-sm-3">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(leiloes)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th>ID</th>
                    <th>Resumo</th>
                    <th>Publicação</th>
                    <th>Abertura</th>
                    <th>Detalhes</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="leilao in leiloes" :class="analisaClassCss(leilao)">
                    <td class="v-middle"><label
                      class="i-checks m-b-none"><input v-on:click.stop="lazyCheck(leilao)" type="checkbox" name="post[]"
                                                       v-model="leilao.selected"
                                                       tabindex="0" aria-checked="false"
                                                       aria-invalid="false"><i></i></label></td>
                    <td @click="open(leilao.id)" role="button" tabindex="0">{{ leilao.id }}</td>
                    <td @click="open(leilao.id)" role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        {{ leilao.titulo }}
                        <span class="label bg-danger text-tiny dk" v-if="isHojeEncerrado(leilao)">Encerrado</span>
                        <span class="label bg-success text-tiny dk" v-else-if="isHoje(leilao)">Hoje</span>
                        <span class="label bg-warning text-tiny dk" v-else-if="isProximoLeilao(leilao)">Próximo leilão</span>
                      </a>
                      <!--<div>-->
                      <!--<small class="text-muted  block text-ellipsis ">126 lotes</small>-->
                      <!--</div>-->
                    </td>
                    <td @click="open(leilao.id)" role="button" tabindex="0">
                      {{ leilao.dataPublicacao ? moment(leilao.dataPublicacao.date).format('DD/MM/YYYY HH:mm') : '-' }}
                    </td>
                    <td @click="open(leilao.id)" role="button" tabindex="0">
                      {{ leilao.dataAbertura ? moment(leilao.dataAbertura.date).format('DD/MM/YYYY HH:mm') : '-' }}
                    </td>
                    <td @click="open(leilao.id)" role="button" tabindex="0" class="text-center">
                      <span v-if="leilao.judicial" class="label bg-info dk text-tiny m-r-xs">Judicial</span>
                      <span class="label bg-light dk text-tiny m-r-xs"> {{ leilao.lotes }} lotes </span>
                      <span class="label bg-light dk text-tiny m-r-xs">Cobrança: {{ +leilao.porcentagemCobranca }}% do arremate</span>
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noLeiloes">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">
                      {{ pagination.atualPage }} / {{ pagination.totalPages }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>


    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Leilao.vue?c2132e28